<template>
  <li
    class="clubcard"
    :class="{
      'is-ourpick': membershipType.our_pick_stamp,
      'card-flip': flipped,
    }"
  >
    <a
      :href="membershipType.store_url"
      class="clubcard__link"
      @click.prevent="cardClicked"
    >
      <span class="sr-only">{{ membershipType.name }}</span>
    </a>
    <div class="clubcard__inner">
      <div class="clubcard__front">
        <div class="clubcard__top">
          <div class="clubcard__logo">
            <img
              data-not-lazy
              :src="logoImgURL"
              :alt="`${membershipType.name} Logo`"
            />
          </div>
          <div class="clubcard__image">
            <img :src="membershipType.hero_image_optimized" alt="" />
          </div>
        </div>
        <div class="clubcard__bottom">
          <div class="clubcard__title">
            <p v-html="membershipType.subheading" />
          </div>
          <ul class="clubcard__meta">
            <li>
              <strong
                >{{ membershipType.bottles_per_delivery }} bottle{{
                  membershipType.bottles_per_delivery > 1 ? 's' : ''
                }}</strong
              >
              {{ membershipType.deliveries_per_year }} Times / Year
            </li>
            <li>
              <strong>{{ shortenedPriceString }}</strong>
              Cost / Shipment
            </li>
          </ul>
          <div class="clubcard__shipping">
            Shipping {{ membershipType.next_shipping_info }}
          </div>
          <div v-if="membershipType.our_pick_stamp" class="ourpick">
            <span class="sr-only">Our Pick for You</span>
          </div>
        </div>
      </div>
      <div class="clubcard__back">
        <div class="clubcard__top">
          <div class="clubcard__logo">
            <img
              data-not-lazy
              :src="backLogoImgURL"
              :alt="`${membershipType.name} Logo`"
            />
          </div>
          <div class="clubcard__copy">
            <p v-html="membershipType.blurb" />
            <p class="hide-for-medium-up f15a">
              <nuxt-link
                :to="membershipType.store_url"
                class="longarrow-white color-white underline"
                >Learn More</nuxt-link
              >
            </p>
          </div>
        </div>
        <div class="clubcard__bottom">
          <div class="clubcard__title">
            <p v-html="membershipType.subheading" />
          </div>
          <ul class="clubcard__meta">
            <li>
              <strong
                >{{ membershipType.bottles_per_delivery }} bottle{{
                  membershipType.bottles_per_delivery > 1 ? 's' : ''
                }}</strong
              >
              {{ membershipType.deliveries_per_year }} Times / Year
            </li>
            <li>
              <strong>{{ shortenedPriceString }}</strong>
              Cost / Shipment
            </li>
          </ul>
          <div class="clubcard__shipping">
            Shipping {{ membershipType.next_shipping_info }}
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  name: 'AnimatedWineClubCard',
  props: {
    membershipType: {
      type: Object,
      required: true,
    },
    usePriceRange: {
      type: Boolean,
      default: false,
      required: false,
    },
    mobile: {
      type: Boolean,
      default: false,
      required: false,
    },
    flipped: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  emits: ['flip'],
  computed: {
    shortenedPriceString() {
      const re = /(?:\$\d*)/gm
      const matchResult = this.membershipType.pricing_info.match(re)
      if (matchResult) {
        const upperPrice = matchResult.slice(-1).pop() || ''
        if (!this.usePriceRange) return upperPrice
        let priceRange = this.membershipType.pricing_info.match(re)[0] || ''
        if (priceRange !== upperPrice) priceRange += '-' + upperPrice
        return priceRange
      }
      return ''
    },
    logoImgURL() {
      return (
        this.membershipType.logo_svg ||
        this.membershipType.logo_image_optimized ||
        ''
      )
    },
    backLogoImgURL() {
      return (
        this.membershipType.back_logo_svg ||
        this.membershipType.back_logo_image_optimized ||
        this.logoImgURL
      )
    },
  },
  methods: {
    cardClicked() {
      if (!this.mobile || this.flipped) {
        this.$router.push(this.membershipType.store_url)
      } else {
        this.$emit('flip')
      }
    },
  },
}
</script>
